import { createTimeFormat } from "@/utils/timeFormat";
import React, { useEffect } from "react";
import {
	Area,
	AreaChart,
	CartesianGrid,
	ResponsiveContainer,
	Tooltip,
	XAxis,
	YAxis,
} from "recharts";
// import { boolean } from "yup";
import { IDailyCount } from "..";

interface ChartSectionProps {
	dailyCount: IDailyCount[];
	selectedDailyNumber: string;
}

const ChartSection = ({ dailyCount, selectedDailyNumber }: ChartSectionProps) => {
	const slicedDailyCount = dailyCount.slice(0, Number(30));
	const reverseDailyCount = [...slicedDailyCount].reverse();
	if (reverseDailyCount[0].date === "") {
		return <></>;
	}
	const [dailyCountDate, setDailyCountDate] =
		React.useState<IDailyCount[]>(reverseDailyCount);
	useEffect(() => {
		const slicedDailyCount = dailyCount.slice(0, Number(selectedDailyNumber));
		const reverseDailyCount = [...slicedDailyCount].reverse();
		setDailyCountDate(reverseDailyCount);
	}, [selectedDailyNumber, dailyCount]);
	/* for (let i = 0; i < dailyCountDate.length; i += 1) {
		dailyCountDate[i].count = i ** 4;
	} */

	const CustomTooltip = ({ active, payload, label }: any) => {
		if (active && payload && payload.length) {
			return (
				<div
					style={{
						backgroundColor: "white",
						border: "1px solid #bbb",
						padding: "0.75rem 0.75rem",
						textAlign: "center",
					}}
				>
					<div>{createTimeFormat(label)}</div>
					<div
						style={{
							fontSize: "1.625rem",
							fontWeight: 700,
							color: "#7d61e3",
							marginTop: "0.5rem",
						}}
					>
						{payload[0].value.toLocaleString()}
					</div>
				</div>
			);
		}

		return null;
	};
	return (
		<ResponsiveContainer width="100%" height="100%">
			<AreaChart
				width={500}
				height={400}
				data={dailyCountDate}
				margin={{
					top: 10,
					right: 50,
					left: 50,
					bottom: 0,
				}}
			>
				<CartesianGrid strokeDasharray="3 3" />
				<XAxis dataKey="date" minTickGap={50} />
				<YAxis
					orientation="right"
					tickFormatter={(tick) => {
						return tick.toLocaleString();
					}}
				/>
				<Tooltip content={<CustomTooltip />} />
				<Area
					type="linear"
					dataKey="count"
					stroke="#7d61e3"
					strokeWidth={2}
					fill="rgba(50, 14, 97, 0.1)"
				/>
			</AreaChart>
		</ResponsiveContainer>
	);
};

export default ChartSection;
